import type { UserRole } from '@/types/auth';

export function isAdministrator(roles: readonly UserRole[]): boolean {
  return roles.includes('admin');
}

export function canManageRegistrations(roles: readonly UserRole[]): boolean {
  return isAdministrator(roles) || roles.includes('registrations_operator');
}

export function canManageContent(roles: readonly UserRole[]): boolean {
  return isAdministrator(roles) || roles.includes('content_editor');
}

export function canAccessBackofficePath(roles: readonly UserRole[], pathname: string): boolean {
  if (pathname === '/') return canManageRegistrations(roles) || canManageContent(roles);
  if (
    ['/cases', '/blog', '/migration', '/website'].some(
      prefix => pathname === prefix || pathname.startsWith(`${prefix}/`)
    )
  )
    return canManageContent(roles);
  if (
    ['/gebruikers', '/instellingen', '/logs'].some(prefix => pathname === prefix || pathname.startsWith(`${prefix}/`))
  )
    return isAdministrator(roles);
  return canManageRegistrations(roles);
}
